import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProjectsListWithPortfolioComponent } from './projects-list-with-portfolio.component';

const routes: Routes = [
  {
    path: '',
    component: ProjectsListWithPortfolioComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProjectsListWithPortfolioRoutingModule { }
